import React from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';

// Reusable alert / confirm dialog (wraps react-bootstrap-sweetalert).
//
// Message:  <AlertComponent type="success" title="Saved" onConfirm={this.hideAlert} />
// Confirm:  <AlertComponent confirm title="Generate bill?" confirmBtnText="Generate"
//               onConfirm={this.save} onCancel={this.hideAlert}>Extra text</AlertComponent>
//
// confirm adds the warning icon and a Cancel button. Any other SweetAlert prop is passed straight through.
export default function AlertComponent(props) {
	var { confirm, ...alertProps } = props;
	var confirmProps = confirm ? { warning: true, showCancel: true } : {};

	return <SweetAlert {...confirmProps} {...alertProps} />;
}
